<template>
    <v-flex :class="contentArea ? `xs${contentArea}` : 'xs6'">
        <v-subheader class="pa-0">{{ title ? title : 'Изображение' }} ({{ `${imageWidth}x${imageHeight}` }})
        </v-subheader>
        <div @click="launchFilePicker()">
            <slot name="activator"/>
        </div>
        <input
            type="file"
            ref="file"
            accept="image/jpeg,image/png"
            :name="uploadFieldName"
            @change="onFileChange($event.target.name, $event.target.files)"
            style="display:none">
        <v-dialog v-model="errorDialog" max-width="300">
            <v-card>
                <v-card-text class="subheading">{{ errorText }}</v-card-text>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn color="info" @click="errorDialog = false" class="v-btn--save">Ok</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="showCropper" persistent max-width="95%">
            <v-card>
                <v-card-text>
                    <vue-croppie
                        ref="croppieRef"
                        :enableExif="true"
                        :enableOrientation="true"
                        :enableResize="false"
                        :enableZoom="true"
                        :mouseWheelZoom="false"
                        :showZoomer="true"
                        :viewport="{ width: imageWidth / 2, height: imageHeight / 2, type: 'square' }"
                        :boundary="{ width: 550, height: 550 }"/>
                </v-card-text>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn color="info" class="v-btn--save" @click="crop">Сохранить</v-btn>
                    <v-btn color="error" class="v-btn--save" @click="cancel">Отмена</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-flex>
</template>

<script>
    export default {
        name: 'uploadImg',
        data: () => ({
            errorDialog: false,
            errorText: '',
            uploadFieldName: 'file',
            maxSize: 1024,
            showCropper: false,
            base64: '',
            imageURL: ''
        }),
        props: {
            value: '',
            imageWidth: Number,
            imageHeight: Number,
            contentArea: Number,
            title: String
        },
        methods: {
            launchFilePicker () {
                this.$refs.file.click()
            },

            onFileChange (fieldName, file) {
                const { maxSize } = this
                let imageFile = file[0]

                if (file.length > 0) {
                    let size = imageFile.size / maxSize / maxSize

                    if (!imageFile.type.match('image/jpeg|image/png')) {
                        this.errorDialog = true
                        this.errorText = 'Выберите корректную картинку JPG или PNG'
                    } else if (size > 1) {
                        this.errorDialog = true
                        this.errorText = 'Файл превышает размер в 1MB'
                    } else {
                        const reader = new FileReader
                        let newImg = URL.createObjectURL(imageFile)
                        this.base64 = ''

                        reader.readAsDataURL(imageFile)
                        reader.onload = () => {
                            const image = new Image
                            image.src = newImg

                            image.onload = () => {
                                if (image.width < this.imageWidth || image.height < this.imageHeight) {
                                    this.errorDialog = true
                                    this.errorText = `Размер изображение должно быть минимум ${this.imageWidth} x ${this.imageHeight} пикселей`
                                } else if (image.width > this.imageWidth && image.height > this.imageHeight) {
                                    this.showCropper = true

                                    setTimeout(() => {
                                        this.$refs.croppieRef.bind({ url: reader.result })
                                    }, 250)
                                } else {
                                    this.imageURL = newImg
                                    this.base64 = reader.result
                                    this.$emit('input', {
                                        base64: this.base64,
                                        imageURL: this.imageURL
                                    })
                                }
                            }
                        }
                    }
                }
            },
            crop () {
                let options = {
                    format: 'base64',
                    size: {
                        width: this.imageWidth,
                        height: this.imageHeight
                    },
                    circle: false
                }
                this.$refs.croppieRef.result(options, output => {
                    this.showCropper = false
                    this.$emit('input', {
                        base64: output,
                        imageURL: output
                    })
                })
            },
            cancel () {
                this.base64 = ''
                this.imageURL = ''
                this.showCropper = false
            }
        }
    }
</script>
